import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment'
@Pipe({
    name: 'gmstranslate',
    standalone: false
})
export class GmstranslatePipe implements PipeTransform {

  transform(transVal: string): string {
    if (environment.translations && environment.translations.hasOwnProperty(transVal)) {
      return environment.translations[transVal];
    }
    return transVal;
  }

}
